import {
  Block,
  Settings,
  SettingSectionTitle,
  SettingsFlexbox
} from '@/components/DybrComponents/StyledServicePagesElements';
import AddPrivacyList from '@/scenes/User/Settings/Privacy/PrivacyLists/AddPrivacyList';
import CustomPrivacyLists from '@/scenes/User/Settings/Privacy/PrivacyLists/CustomPrivacyLists';

function PrivacyLists() {
  return (
    <Block>
      <SettingsFlexbox>
        <SettingSectionTitle>
          <h4>Списки</h4>
          <p>
            Здесь вы можете создать списки для гибких настроек доступа к вашему
            блогу. Вы можете выбрать любого пользователя на Дыбре, начав
            печатать его ник в поле "ники пользователей"
          </p>
        </SettingSectionTitle>
        <Settings>
          <CustomPrivacyLists />
          <AddPrivacyList />
        </Settings>
      </SettingsFlexbox>
    </Block>
  );
}

export default PrivacyLists;
